export function formatNumber(value: number, decimals: number = 2): string {
  if (value === 0) return '0';
  if (value < 0.01) return value.toFixed(4);
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  });
}

export function formatCurrency(value: number, currency: string): string {
  try {
    const isZeroDecimal = value >= 1000 || Number.isInteger(value);
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: currency === 'USD' ? 2 : isZeroDecimal ? 0 : 2,
    }).format(value);
  } catch {
    // Fallback for unsupported currency codes
    return `${currency} ${value.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
  }
}
